import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CGMCalibrationPayload = {
  current_time?: number;
  timestamp?: number;
  cal_timestamp?: number;
  value?: number;
  current_display_value?: number;
};

export type CGMCalibrationEvent = {
  currentTime?: number;
  timestamp?: number;
  calTimestamp?: number;
  value?: number;
  currentDisplayValue?: number;
};

const cgmCalibrationSchema = z.object({
  current_time: cz.permissive(z.number()),
  timestamp: cz.permissive(z.number()),
  cal_timestamp: cz.permissive(z.number()),
  value: cz.permissive(z.number()),
  current_display_value: cz.permissive(z.number()),
});

export const LID_CGM_CALIBRATION = {
  value: 0xa0,
  name: "CGM Calibration",
  format: "iiihh",
  fields: ["current_time", "timestamp", "cal_timestamp", "value", "current_display_value"],
  postprocess: rec => ({
    currentTime: rec.current_time,
    timestamp: rec.timestamp,
    calTimestamp: rec.cal_timestamp,
    value: rec.value,
    currentDisplayValue: rec.current_display_value,
  }),
  schema: cgmCalibrationSchema,
} as const satisfies TandemEventDefinition<CGMCalibrationPayload, CGMCalibrationEvent>;
